import { connect } from 'react-redux';

import { IMobileLayoutStoreProps, MobileLayout } from '.';
import { IAppState } from '../../../../store';

function mapStateToProps(state: IAppState): IMobileLayoutStoreProps {
  return {
    activeScreen: state.activeScreen,
  };
}

export const MobileLayoutContainer = connect<IMobileLayoutStoreProps, {}, {}>(mapStateToProps)(MobileLayout);
